import React, { Component } from "react";
import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import AuthApi from "../../Services/Authapi";
import TableComponent from "../../Layouts/TableComponent";
import Breadcrumb from "../../Layouts/Breadcrumb";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import swal from "sweetalert";
import TextField from '@material-ui/core/TextField';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import AuthCheckComponent from '../../Layouts/Token';
import InputAdornment from "@material-ui/core/InputAdornment";
import FilterListIcon from "@material-ui/icons/FilterList";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import DialogActions from '@mui/material/DialogActions';
import ls from "local-storage";
import { createSwalLoaderNode } from "../../Layouts/swalLoader";
import "./Check.css"

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  MenuItem,
  Paper,
  Select,
  Button,
  // Checkbox,
  // IconButton,
} from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
// import FontAwesomeIconComponent from "../../Layouts/FontAwesomeIconComponent";
// import { DatePicker } from '@mui/lab';
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';

export const promptRejectionRemark = (titleText = "Reject Time Entry") => {
  return new Promise((resolve) => {
    const wrapper = document.createElement("div");
    wrapper.style.textAlign = "left";
    wrapper.style.padding = "5px 0";

    const input = document.createElement("input");
    input.type = "text";
    input.placeholder = "Enter Rejection Remark *";
    input.style.width = "100%";
    input.style.padding = "10px";
    input.style.boxSizing = "border-box";
    input.style.border = "1px solid #cbd5e1";
    input.style.borderRadius = "6px";
    input.style.marginTop = "4px";
    input.style.setProperty("font-weight", "normal", "important");
    input.style.fontSize = "14px";

    const errorMsg = document.createElement("div");
    errorMsg.style.color = "#dc2626";
    errorMsg.style.fontSize = "13px";
    errorMsg.style.marginTop = "6px";
    errorMsg.style.fontWeight = "600";
    errorMsg.style.display = "none";
    errorMsg.innerText = "Please enter rejection remark *";

    wrapper.appendChild(input);
    wrapper.appendChild(errorMsg);

    swal({
      title: titleText,
      content: wrapper,
      buttons: {
        cancel: {
          text: "Cancel",
          value: null,
          visible: true,
          closeModal: true,
        },
        confirm: {
          text: "Reject",
          value: true,
          closeModal: false,
        },
      },
      dangerMode: true,
    }).then((isConfirm) => {
      if (!isConfirm) {
        resolve(null);
        return;
      }
      const val = input.value ? input.value.trim() : "";
      if (!val) {
        errorMsg.style.display = "block";
        input.style.borderColor = "#dc2626";
        input.focus();
      } else {
        swal.close();
        resolve(val);
      }
    });

    setTimeout(() => {
      input.focus();
      input.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          const val = input.value ? input.value.trim() : "";
          if (!val) {
            errorMsg.style.display = "block";
            input.style.borderColor = "#dc2626";
          } else {
            swal.close();
            resolve(val);
          }
        } else {
          if (errorMsg.style.display === "block") {
            errorMsg.style.display = "none";
            input.style.borderColor = "#cbd5e1";
          }
        }
      });
    }, 100);
  });
};

class Check extends Component {
  constructor(props) {
    super(props);
    this.state = {
      getData: [],
      count: 0,
      isLoading: true,
      pageStatus: false,
      isApproved: 0,
      searchQuery: "",
      suggestions: [],
      selectedTimeEntry: null,
      showModalFromNotification: false,
      openFilterDialog: false,
      startDate: "",
      endDate: "",

      tableTh: [
        {
          id: "select",
          numeric: false,
          disablePadding: true,
          label: (
            <div className="wrap-check-20">
              <label>
                <input
                  type="checkbox"
                  checked={this.isAllSelected()}
                  onChange={this.handleSelectAllEntries}
                />
                <span className="checkbox"></span>
              </label>
            </div>
          ),
          sortable: false,
        },
        {
          id: "name",
          numeric: false,
          disablePadding: true,
          label: "Employee ID",
          sortable: true,
        },
        {
          id: "Name",
          numeric: false,
          disablePadding: true,
          label: "Name",
          sortable: true,
        },
        {
          id: "date",
          numeric: false,
          disablePadding: true,
          label: "Date",
          sortable: true,
        },
        {
          id: "in_time",
          numeric: false,
          disablePadding: true,
          label: "In Time",
          sortable: true,
        },
        {
          id: "out_time",
          numeric: false,
          disablePadding: true,
          label: "Out Time",
          sortable: true,
        },
        {
          id: "duration",
          numeric: false,
          disablePadding: true,
          label: "Hours/Min",
          sortable: true,
        },
        {
          id: "reason_display",
          numeric: false,
          disablePadding: true,
          label: "Reason",
          sortable: true,
        },
        {
          id: "status",
          numeric: false,
          disablePadding: true,
          label: "Status",
          sortable: false,
        },
        {
          id: "action",
          numeric: false,
          disablePadding: true,
          label: "Action",
          sortable: false,
          // style: { width: "100px" },
        },
        // {
        //   id: "action",
        //   numeric: false,
        //   disablePadding: true,
        //   label: "",
        //   sortable: false,
        //   // style: { width: "100px" },
        // },
      ],
      bulkAction: '',
      selectedEntries: [],
      isAdmin: false,
      editDialogOpen: false,
      editEntry: null,
      formErrors: {},
      selectedMonth: '',
      selectedStatus: '',
      selectedDate: new Date(),
      selectedMonthYear: new Date(),
      filterModalMonthYear: new Date(),
      filterModalStatus: '',
      selectedRows: [],
      selectedBulkAction: '',
      rejectionRemark: '',
      isFilterApplied: false,
    };
    this.getUserData = this.getUserData.bind(this);
    this.decline = this.decline.bind(this);
    this.accept = this.accept.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.handleSuggestionClick = this.handleSuggestionClick.bind(this);
    this.handleBulkActionChange = this.handleBulkActionChange.bind(this);
    this.handleBulkActionSubmit = this.handleBulkActionSubmit.bind(this);
    this.handleEntrySelect = this.handleEntrySelect.bind(this);
    this.viewDetails = this.viewDetails.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleEditChange = this.handleEditChange.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    this.handleEditDialogClose = this.handleEditDialogClose.bind(this);
    this.handleMonthChange = this.handleMonthChange.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onRowsPerPageChange = this.onRowsPerPageChange.bind(this);
  }

  timeEntryModalBlue = "var(--hrms-primary-blue-end)";

  isPrivilegedRole = () => ["Super Admin", "Admin"].includes(ls("roles"));

  componentDidMount() {
    if (this.props && this.props.authToken === false) {
      // this.props.history.push("/login");
    }
    this.getUserData().then(() => {
      this.handleSearch();
    });

    const fromNotificationPanel = sessionStorage.getItem('fromNotificationPanel');
    if (this.props.location.state && this.props.location.state.notificationData && fromNotificationPanel) {
      const { dataId } = this.props.location.state.notificationData;
      this.fetchTimeEntryDetails(dataId);
      this.setState({ showModalFromNotification: true });
      sessionStorage.removeItem('fromNotificationPanel');
    }

    const fromDashboard = sessionStorage.getItem('fromDashboard');
    if (this.props.location.state && this.props.location.state.timeEntryDetails && fromDashboard) {
      const { timeEntryDetails } = this.props.location.state;
      this.setState({ selectedTimeEntry: timeEntryDetails, showModalFromNotification: true });
      sessionStorage.removeItem('fromDashboard');
    }

    this.setState({ selectedMonthYear: new Date() });
  }
  componentWillReceiveProps(props) {
    if (props && props.authToken === false) {
      // props.history.push("/login");
    }
  }

  handleSelectAllEntries = () => {
    const { page, rowsPerPage, getData, selectedEntries } = this.state;
    const currentPageEntries = getData.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
    const currentEntryIds = currentPageEntries.map(entry => entry.id);

    const allSelected = currentEntryIds.every(id => selectedEntries.includes(id));

    if (allSelected) {
      // Deselect all on current page
      this.setState(prevState => ({
        selectedEntries: prevState.selectedEntries.filter(id => !currentEntryIds.includes(id)),
      }));
    } else {
      // Select all on current page
      this.setState(prevState => ({
        selectedEntries: [...new Set([...prevState.selectedEntries.filter(id => !currentEntryIds.includes(id)), ...currentEntryIds])],
      }));
    }
  };

  isAllSelected = () => {
    const { getData = [], selectedEntries = [] } = this.state || {};
    return getData.length > 0 && getData.every(entry => selectedEntries.includes(entry.id));
  };

  getUserData = async (e) => {
    this.setState({ isLoading: true });
    const isAdmin = this.isPrivilegedRole();
    let userData;
    if (isAdmin) {
      userData = await AuthApi.chekUserData();
    } else {
      userData = await AuthApi.TimeEntrshowuser(ls("user").id);
    }
    if (userData && userData.status === true) {
      this.setState({
        getData: userData.data.map(entry => ({
          ...entry,
          reason_display: entry.reason || entry.entry_reason || entry.time_entry_reason || entry.remark || entry.reject_remark || entry.rejection_remark || "-",
          statusLabel: this.getStatusLabel(entry.is_approved)
        })),
        count: userData.data.length,
        isAdmin: isAdmin,
      }, this.handleSearch);
    } else {
      this.setState({
        getData: [],
        count: 0,
        filterData: [],
        isAdmin: isAdmin,
      });
    }
    this.setState({ isLoading: false });
  };

  getStatusLabel = (isApproved) => {
    const raw = String(isApproved ?? 1).toLowerCase();
    if (raw === "0" || raw === "approved") {
      return <span className="status-approved">Approved</span>;
    }
    if (raw === "2" || raw === "rejected" || raw === "declined") {
      return <span className="status-rejected">Rejected</span>;
    }
    return <span className="status-pending">Pending</span>;
  };

  fetchTimeEntryDetails = async (dataId) => {
    try {
      const userData = this.isPrivilegedRole()
        ? await AuthApi.chekUserData()
        : await AuthApi.TimeEntrshowuser(ls("user").id);
      if (userData && userData.status === true) {
        const timeEntry = userData.data.find((entry) => entry.id === dataId);
        if (timeEntry) {
          this.setState({
            selectedTimeEntry: timeEntry,
            showModalFromNotification: true,
          });
        }
      }
    } catch (error) {
      console.error("Error fetching time entry details:", error);
    }
  };

  accept = async (id) => {
    const user = ls("user");
    const userName = `${user.firstName} ${user.lastName}`;
    const ticketUpdateData = {
      is_approved: "0",
      userName: userName,
    };

    swal({
      title: "Are you sure?",
      text: "Do you want to approve this entry?",
      icon: "warning",
      buttons: ["Cancel", "Yes"],
    }).then(async (confirm) => {
      if (confirm) {
        let user = await AuthApi.approveTime(ticketUpdateData, id);
        if (user && user.status === true) {
          this.setState({
            pageStatus: true,
          });
          this.getUserData();
          setTimeout(() => this.setState({ pageStatus: false }), 500);
          swal("Done!", "You have approved the entry!", "success");
        } else {
          swal("Error!", "There was an error approving the entry.", "error");
        }
      }
    });
  };

  decline = async (id) => {
    const user = ls("user");
    const userName = `${user.firstName} ${user.lastName}`;
    const rejectionRemark = await promptRejectionRemark("Reject Time Entry");
    if (rejectionRemark) {
      const ticketUpdateData = {
        is_approved: "2",
        userName: userName,
        remark: rejectionRemark,
      };
      let userCheck = await AuthApi.approveTime(ticketUpdateData, id);
      if (userCheck && userCheck.status === true) {
        this.setState({
          pageStatus: true,
          rejectionRemark,
        });
        this.getUserData();
        setTimeout(() => this.setState({ pageStatus: false }), 500);
        swal("Done!", "You have rejected the entry!", "success");
      } else {
        swal("Error!", "There was an error rejecting the entry.", "error");
      }
    }
  };

  parseItemDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string') return null;
    const clean = dateStr.trim();
    if (clean.includes("-")) {
      const parts = clean.split("-").map(Number);
      if (parts.length === 3 && !parts.some(isNaN)) {
        if (parts[0] > 1000) {
          return new Date(parts[0], parts[1] - 1, parts[2]);
        } else {
          return new Date(parts[2], parts[1] - 1, parts[0]);
        }
      }
    }
    const parsed = new Date(clean);
    return isNaN(parsed.getTime()) ? null : parsed;
  };

  handleChange(e) {
    const searchQuery = e.target.value;
    const query = searchQuery ? searchQuery.trim().toLowerCase() : "";
    const suggestions = (this.state.getData || []).filter((item) => {
      if (!query) return false;
      const empId = (item.name || "").toString().toLowerCase();
      const empName = (item.Name || item.userName || item.user_name || "").toString().toLowerCase();
      const reason = (item.reason_display || item.reason || "").toString().toLowerCase();
      return empId.includes(query) || empName.includes(query) || reason.includes(query);
    });
    this.setState({ searchQuery, suggestions }, this.handleSearch);
  }

  handleCloseModal = () => {
    this.setState({ showModalFromNotification: false, selectedTimeEntry: null });
  };

  handleSearch = () => {
    const {
      searchQuery,
      selectedMonthYear,
      selectedStatus,
      startDate,
      endDate,
      getData,
      isFilterApplied,
    } = this.state;

    const query = searchQuery ? searchQuery.trim().toLowerCase() : "";

    const filterData = (getData || []).filter((item) => {
      // 1. Search Query Matching across all fields
      let matchesQuery = true;
      if (query) {
        const empId = (item.name || item.emp_id || item.employee_id || "").toString().toLowerCase();
        const empName = (item.Name || item.userName || item.user_name || item.first_name || item.firstName || "").toString().toLowerCase();
        const itemDateStr = (item.date || "").toString().toLowerCase();
        const reason = (item.reason_display || item.reason || item.entry_reason || item.remark || item.rejection_remark || "").toString().toLowerCase();
        const inTime = (item.in_time || "").toString().toLowerCase();
        const outTime = (item.out_time || "").toString().toLowerCase();
        const duration = (item.duration || "").toString().toLowerCase();

        matchesQuery =
          empId.includes(query) ||
          empName.includes(query) ||
          itemDateStr.includes(query) ||
          reason.includes(query) ||
          inTime.includes(query) ||
          outTime.includes(query) ||
          duration.includes(query);
      }

      // 2. Month / Year filter (only if filter explicitly applied)
      let matchesMonthYear = true;
      if (isFilterApplied && selectedMonthYear) {
        const itemDate = this.parseItemDate(item.date);
        if (itemDate) {
          matchesMonthYear =
            itemDate.getMonth() === selectedMonthYear.getMonth() &&
            itemDate.getFullYear() === selectedMonthYear.getFullYear();
        }
      }

      // 3. Status filter
      let matchesStatus = true;
      if (selectedStatus) {
        let statusStr = "pending";
        const raw = String(item.is_approved ?? 1).toLowerCase();
        if (raw === "0" || raw === "approved") statusStr = "approved";
        else if (raw === "2" || raw === "rejected" || raw === "declined") statusStr = "rejected";
        else statusStr = "pending";

        matchesStatus = statusStr.toLowerCase() === selectedStatus.toLowerCase();
      }

      // 4. Date Range filter
      let matchesRange = true;
      if (startDate || endDate) {
        const itemDate = this.parseItemDate(item.date);
        if (itemDate) {
          const start = startDate ? new Date(startDate) : null;
          const end = endDate ? new Date(endDate) : null;
          if (end) end.setHours(23, 59, 59, 999);
          matchesRange = (!start || itemDate >= start) && (!end || itemDate <= end);
        }
      }

      return matchesQuery && matchesMonthYear && matchesStatus && matchesRange;
    });

    this.setState({ filterData });
  };


  clearSearch = () => {
    this.setState({ searchQuery: "", suggestions: [] }, this.handleSearch);
  };

  handleSuggestionClick = (suggestion) => {
    this.setState({ searchQuery: suggestion.name, suggestions: [] }, this.handleSearch);
  };

  handleBulkActionChange(event) {
    this.setState({ selectedBulkAction: event.target.value });
  }

  getBulkSelectedEntries = () => {
    const { selectedEntries, filterData = [], getData = [] } = this.state;
    const availableEntries = (filterData.length > 0 ? filterData : getData).filter(
      (entry) => selectedEntries.includes(entry.id) && (String(entry.is_approved) === "1" || String(entry.is_approved).toLowerCase() === "pending")
    );

    return availableEntries;
  };

  runBulkApproval = async (entries, payload, successMessage, stateUpdates = {}) => {
    swal({
      title: "Please wait",
      text: "Processing selected entries...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: createSwalLoaderNode(),
    });

    try {
      for (const entry of entries) {
        await AuthApi.approveTime(payload, entry.id);
      }

      await this.getUserData();
      this.setState({
        pageStatus: true,
        selectedEntries: [],
        selectedBulkAction: '',
        ...stateUpdates,
      });
      setTimeout(() => this.setState({ pageStatus: false }), 500);
      swal("Done!", successMessage, "success");
    } catch (error) {
      console.error("Bulk action failed:", error);
      swal("Error!", "There was an error processing selected entries.", "error");
    }
  };

  handleBulkActionSubmit() {
    const { selectedBulkAction } = this.state;
    const validEntries = this.getBulkSelectedEntries();

    if (!selectedBulkAction || validEntries.length === 0) {
      return;
    }

    const user = ls("user");
    const userName = `${user.firstName} ${user.lastName}`;

    if (selectedBulkAction === 'reject') {
      swal({
        title: "Reject Time Entries",
        text: `Please enter remark for rejecting ${validEntries.length} entries:`,
        className: "rejection-remark-swal",
        content: {
          element: "input",
          attributes: {
            placeholder: "Enter Rejection Remark",
            type: "text",
          },
        },
        buttons: ["Cancel", "Reject"],
        dangerMode: true,
      }).then(async (remark) => {
        const rejectionRemark = typeof remark === "string" ? remark.trim() : "";
        if (remark === null) {
          return;
        }
        if (!rejectionRemark) {
          swal("Cancelled", "Please enter rejection remark.", "error");
          return;
        }

        await this.runBulkApproval(
          validEntries,
          { is_approved: "2", userName, remark: rejectionRemark },
          "Selected entries have been rejected.",
          { rejectionRemark }
        );
      });
      return;
    }

    swal({
      title: "Are you sure?",
      text: `You are about to approve ${validEntries.length} entries.`,
      icon: "warning",
      buttons: ["Cancel", "Yes"],
    }).then(async (confirm) => {
      if (confirm) {
        await this.runBulkApproval(
          validEntries,
          { is_approved: "0", userName },
          "Selected entries have been approved."
        );
      }
    });
  }

  handleEntrySelect = (entryId) => {
    this.setState((prevState) => {
      const selectedEntries = prevState.selectedEntries.includes(entryId)
        ? prevState.selectedEntries.filter(id => id !== entryId)
        : [...prevState.selectedEntries, entryId];
      return {
        selectedEntries,
      };
    });
  };

  viewDetails(id) {
    const selectedTimeEntry = this.state.getData.find(entry => entry.id === id);
    this.setState({ selectedTimeEntry, showModalFromNotification: true });
  }

  handleEditClick(entry) {
    this.setState({
      editDialogOpen: true,
      formErrors: {},
      editEntry: {
        ...entry,
        reason: entry.reason || entry.entry_reason || entry.time_entry_reason || "",
      }
    });
  }

  handleEditChange(e) {
    const { name, value } = e.target;
    this.setState(prevState => {
      const updatedErrors = { ...prevState.formErrors };
      const hasValue = typeof value === "string" ? value.trim() : value;

      if (updatedErrors[name] && hasValue) {
        delete updatedErrors[name];
      }

      return {
        editEntry: {
          ...prevState.editEntry,
          [name]: name === 'date' ? this.formatDateToDisplay(value) : value,
        },
        formErrors: updatedErrors,
      };
    });
  }

  async handleEditSubmit() {
    const { editEntry } = this.state;
    const user = ls("user");
    const formErrors = {};

    if (!editEntry.reason || !editEntry.reason.trim()) {
      formErrors.reason = "Reason is required";
    }

    if (Object.keys(formErrors).length > 0) {
      this.setState({ formErrors });
      return;
    }

    try {
      const formattedEntry = {
        user_id: editEntry.user_id,
        date: this.formatDateToInput(editEntry.date),
        in_time: editEntry.in_time,
        out_time: editEntry.out_time,
        duration: editEntry.duration,
        is_approved: editEntry.is_approved,
        reason: editEntry.reason.trim(),
      };
      const response = await AuthApi.editTime(user.id, editEntry.id, formattedEntry);
      if (response && response.status === true) {
        this.setState({ editDialogOpen: false, editEntry: null, formErrors: {} });
        this.getUserData();
        swal("Success!", "Time entry updated successfully.", "success");
      } else {
        swal("Error!", "Failed to update time entry.", "error");
      }
    } catch (error) {
      console.error("Error updating time entry:", error);
      swal("Error!", "An error occurred while updating the time entry.", "error");
    }
  }

  handleEditDialogClose() {
    this.setState({ editDialogOpen: false, editEntry: null, formErrors: {} });
  }

  formatDateToInput(date) {
    const [day, month, year] = date.split('-');
    return `${year}-${month}-${day}`;
  }

  formatDateToDisplay(date) {
    const [year, month, day] = date.split('-');
    return `${day}-${month}-${year}`;
  }

  handleDelete = async (id) => {
    try {
      const response = await AuthApi.deletetimeentry(id);
      if (response && response.status === true) {
        this.getUserData();
        swal("Success!", "Time entry deleted successfully.", "success");
      } else {
        swal("Error!", "Failed to delete time entry.", "error");
      }
    } catch (error) {
      console.error("Error deleting time entry:", error);
      swal("Error!", "An error occurred while deleting the time entry.", "error");
    }
  };

  handleMonthChange(event) {
    this.setState({ selectedMonth: event.target.value }, this.handleSearch);
  }

  handleStatusChange(event) {
    this.setState({ selectedStatus: event.target.value }, this.handleSearch);
  }

  handleFilterStatusChange = (event) => {
    this.setState({ filterModalStatus: event.target.value });
  };

  handleFilterMonthYearChange = (event) => {
    const date = new Date(event.target.value);
    if (!Number.isNaN(date.getTime())) {
      this.setState({ filterModalMonthYear: date });
    }
  };

  handleDateChange = (event) => {
    const date = new Date(event.target.value);
    this.setState({ selectedMonthYear: date }, this.handleSearch);
  };

  onPageChange = (newPage) => {
    this.setState({
      page: newPage,
      selectedEntries: [], // Reset selection
    });
  };

  onRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    this.setState({
      rowsPerPage: newRowsPerPage,
      page: 0, // Reset to first page
      selectedEntries: [], // Reset selection
    });
  };

  openFilterModal = () => {
    this.setState({
      openFilterDialog: true,
      filterModalMonthYear: this.state.selectedMonthYear,
      filterModalStatus: this.state.selectedStatus,
    });
  };

  getActiveFilterCount = () => {
    let count = 0;
    if (this.state.isFilterApplied && this.state.selectedMonthYear) count++;
    if (this.state.startDate || this.state.endDate) count++;
    if (this.state.selectedStatus) count++;
    if (this.state.searchQuery) count++;
    return count;
  };

  render() {
    const classes = this.props;
    const filterData = this.state.filterData || this.state.getData;
    const permissions = (this.props.authUser && Array.isArray(this.props.authUser.userAccess)) ? this.props.authUser.userAccess : [];
    const { editDialogOpen, editEntry, formErrors, selectedTimeEntry, showModalFromNotification, isAdmin } = this.state;
    const entryReason = selectedTimeEntry && (selectedTimeEntry.reason || selectedTimeEntry.entry_reason || selectedTimeEntry.time_entry_reason);
    const rejectionRemark = selectedTimeEntry && (selectedTimeEntry.remark || selectedTimeEntry.reject_remark || selectedTimeEntry.rejection_remark);
    const showBulkActionBar =
      permissions.includes("Timeentry.Bulkapprove") ||
      permissions.includes("Timeentry.Bulkreject");
    const bulkActionControls = showBulkActionBar ? (
      <div className="user-check-bulk-actions">
        <Select
          value={this.state.selectedBulkAction}
          onChange={this.handleBulkActionChange}
          displayEmpty
          className="user-check-bulk-select custom-filter-select"
          style={{ backgroundColor: "transparent" }}
          MenuProps={{ classes: { paper: 'filter-time-entries-menu' } }}
        >
          <MenuItem value="" disabled>Bulk Action</MenuItem>
          {permissions.includes("Timeentry.Bulkapprove") && (
            <MenuItem value="approve">Approve</MenuItem>
          )}
          {permissions.includes("Timeentry.Bulkreject") && (
            <MenuItem value="reject">Reject</MenuItem>
          )}
        </Select>
        <Button
          variant="contained"
          color="primary"
          onClick={this.handleBulkActionSubmit}
          disabled={!this.state.selectedBulkAction || this.state.selectedEntries.length === 0}
        >
          Go
        </Button>
      </div>
    ) : null;
    var d = new Date(),
      month = '' + (d.getMonth() + 1),
      day = '' + (d.getDate() - 1),
      year = d.getFullYear();
    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    var ds = [year, month, day].join('-');

    return (
      <div className="check-container">
        <AuthCheckComponent authToken={this.props.authToken} />
        <Header
          {...this.props}
          authUser={this.props.authUser}
          setAutUser={this.props.setAutUser}
          component={
            <div className="check-user-module" style={{ marginBottom: "11%" }}>
              <div className="holiday-breadcrumb-card">
                  <Breadcrumb
                    {...this.props}
                    primaryPageName="Check"
                    primaryPageLink="/time-entries"
                    isSecondaryPage={false}
                    secondaryPageName=""
                  />
              </div>

              <Dialog
                open={this.state.openFilterDialog}
                onClose={() => this.setState({ openFilterDialog: false })}
                disableScrollLock={true}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                  style: {
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  },
                }}
              >
                <DialogTitle
                  style={{
                    textAlign: "center",
                    background: "linear-gradient(180deg, var(--hrms-primary-blue-start, #036dda) 0%, var(--hrms-primary-blue-end, #036dda) 100%)",
                    color: "#fff",
                    padding: "10px",
                    position: "relative",
                  }}
                >
                  Filter Time Entries
                  <CloseIcon
                    style={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      cursor: "pointer",
                      color: "#fff",
                      width: 28,
                      height: 28,
                    }}
                    onClick={() => this.setState({ openFilterDialog: false })}
                  />
                </DialogTitle>

                <DialogContent>
                  <TextField
                    label="Select Month/Year"
                    type="month"
                    fullWidth
                    value={this.state.filterModalMonthYear.toISOString().slice(0, 7)}
                    onChange={this.handleFilterMonthYearChange}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      min: "2020-01",
                      max: new Date().toISOString().slice(0, 7),
                    }}
                    style={{ marginBottom: "20px" }}
                  />

                  <Select
                    className="custom-filter-select"
                    value={this.state.filterModalStatus}
                    onChange={this.handleFilterStatusChange}
                    displayEmpty
                    fullWidth
                    style={{ marginBottom: "25px" }}
                    MenuProps={{
                      classes: {
                        paper: "filter-time-entries-menu",
                      },
                    }}
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="approved">Approved</MenuItem>
                    <MenuItem value="pending">Pending</MenuItem>
                    <MenuItem value="rejected">Rejected</MenuItem>
                  </Select>

                  <DialogActions>
                    <Button
                      variant="contained"
                      onClick={() => {
                        this.setState({
                          openFilterDialog: false,
                          selectedMonthYear: this.state.filterModalMonthYear,
                          selectedStatus: this.state.filterModalStatus,
                          isFilterApplied: true,
                        }, this.handleSearch);
                      }}
                      style={{ backgroundColor: "#1b6e95", color: "#fff", textTransform: 'capitalize' }}
                    >
                      Apply
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() =>
                        this.setState(
                          {
                            selectedStatus: "",
                            searchQuery: "",
                            startDate: "",
                            endDate: "",
                            selectedMonthYear: new Date(),
                            filterModalMonthYear: new Date(),
                            filterModalStatus: "",
                            isFilterApplied: false,
                          },
                          this.handleSearch
                        )
                      }
                      style={{ textTransform: 'capitalize' }}
                    >
                      Clear
                    </Button>
                  </DialogActions>
                </DialogContent>
              </Dialog>

              <TableComponent
                shellClassName="holiday-table-shell"
                extraHeaderContent={
                  <React.Fragment>
                    <Button
                      variant="contained"
                      color="primary"
                      className="common-action-button"
                      onClick={this.openFilterModal}
                      style={{
                        textTransform: "none",
                      }}
                    >
                      <FilterListIcon style={{ marginRight: this.getActiveFilterCount() > 0 ? '4px' : '0' }} />
                      {this.getActiveFilterCount() > 0 && `(${this.getActiveFilterCount()})`}
                    </Button>

                    <div style={{ position: 'relative', marginLeft: '15px' }}>
                      <TextField
                        label="Search"
                        value={this.state.searchQuery}
                        onChange={this.handleChange}
                        variant="outlined"
                        style={{ width: "260px" }}
                        InputLabelProps={{
                          shrink: this.state.searchQuery !== "",
                          style: {
                            color: 'var(--hrms-primary-blue-end, #036dda)',
                            transform: this.state.searchQuery !== "" ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 11px) scale(1)',
                            transition: 'transform 0.2s ease-in-out'
                          }
                        }}
                        InputProps={{
                          style: {
                            backgroundColor: 'lightgray',
                            borderRadius: '25px',
                            height: "40px"
                          },
                          endAdornment: (
                            <InputAdornment position="end">
                              {this.state.searchQuery && (
                                <ClearIcon onClick={this.clearSearch} style={{ cursor: 'pointer' }} />
                              )}
                              <SearchIcon onClick={this.handleSearch} style={{ cursor: 'pointer' }} />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                  </React.Fragment>
                }
                {...this.props}
                selected={this.state.selectedEntries}
                setSelected={(selectedEntries) => this.setState({ selectedEntries })}
                onPageChange={this.onPageChange}
                onRowsPerPageChange={this.onRowsPerPageChange}
                tableTh={this.state.tableTh.map((column) => {
                  if (column.id === "select") {
                    const currentPageEntries = this.state.getData.slice(this.state.page * this.state.rowsPerPage, (this.state.page + 1) * this.state.rowsPerPage);
                    const currentEntryIds = currentPageEntries.map(entry => entry.id);
                    return {
                      ...column,
                      label: currentPageEntries.length > 0 ? (
                        <div className="wrap-check-20">
                          <label>
                            <input
                              type="checkbox"
                              checked={currentEntryIds.every(id => this.state.selectedEntries.includes(id))}
                              onChange={this.handleSelectAllEntries}
                            />
                            <span className="checkbox"></span>
                          </label>
                        </div>
                      ) : null,
                    };
                  }
                  return column;
                })}
                tableData={filterData.map((entry) => ({
                  ...entry,
                  select: (
                    <div className="wrap-check-20">
                      <label>
                        <input
                          type="checkbox"
                          checked={this.state.selectedEntries.includes(entry.id)}
                          onChange={() => this.handleEntrySelect(entry.id)}
                        />
                        <span className="checkbox"></span>
                      </label>
                    </div>
                  ),
                  status: entry.statusLabel,
                }))} 
                tableCount={filterData.length}
                isLoading={this.state.isLoading}
                tablePagestatus={this.state.pageStatus}
                colNameToShow={["select", "name", "Name", "date", "in_time", "out_time", "duration", "reason_display", "status"]}
                openPopUp={false}
                actionBtns={[
                  permissions.includes("Timeentry.Approve") && 'approve111',
                  permissions.includes("Timeentry.Reject") && 'reject11',
                  permissions.includes("Timeentry.Viewdetails") && 'viewdetails',
                  permissions.includes("Timeentry.Edit") && 'edit',
                  permissions.includes("Timeentry.Deletetimeentry") && 'deletetimeentry',
                ]}
                modelName={"Check"}
                addRoute={'/time-entries/add'}
                openPopUpUpdate={false}
                viewDetails={this.viewDetails}
                handleEditClick={this.handleEditClick}
                handleDelete={this.handleDelete}
                acceptRow={this.accept}
                rejectRow={this.decline}
                selectedRows={this.state.selectedRows}
                {...(showBulkActionBar
                  ? {
                    bottomBarContent: bulkActionControls,
                    bottomBarClassName: "user-check-table-bottom-bar",
                  }
                  : {})}
              />
            </div>
          }
        />
        <Footer {...this.props} />

        {showModalFromNotification && selectedTimeEntry && (
          <Dialog
            open={showModalFromNotification}
            onClose={this.handleCloseModal}
            disableScrollLock={true}
            maxWidth="xs"
            fullWidth
            PaperProps={{
              style: {
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                width: "350px",
              },
            }}
          >
            <div style={{ position: "relative" }}>
              <DialogTitle
                style={{
                  textAlign: "center",
                  padding: "10px",
                  background: "linear-gradient(180deg, var(--hrms-primary-blue-start, #036dda) 0%, var(--hrms-primary-blue-end, #036dda) 100%)",
                  color: "#fff",
                  borderTopLeftRadius: "8px",
                  borderTopRightRadius: "8px",
                }}
              >
                Time Entry Details
              </DialogTitle>
              <CloseIcon
                style={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  cursor: "pointer",
                  color: "#fff",
                  width: 28,
                  height: 28,
                }}
                onClick={this.handleCloseModal}
              />
              <DialogContent>
                <div>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Employee ID</b></td>
                        <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                        <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{selectedTimeEntry.name}</td>
                      </tr>
                      <tr>
                        <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Name</b></td>
                        <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                        <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{selectedTimeEntry.Name}</td>
                      </tr>
                      <tr>
                        <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Date</b></td>
                        <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                        <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{selectedTimeEntry.date}</td>
                      </tr>
                      <tr>
                        <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>In Time</b></td>
                        <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                        <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{selectedTimeEntry.in_time}</td>
                      </tr>
                      <tr>
                        <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Out Time</b></td>
                        <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                        <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{selectedTimeEntry.out_time}</td>
                      </tr>
                      <tr>
                        <td style={{ padding: "8px" }}><b>Duration</b></td>
                        <td style={{ padding: "8px", textAlign: "center" }}>:</td>
                        <td style={{ padding: "8px" }}>{selectedTimeEntry.duration}</td>
                      </tr>
                      {entryReason && (
                        <tr>
                          <td style={{ padding: "8px", borderTop: "1px solid #ddd" }}><b>Reason</b></td>
                          <td style={{ padding: "8px", borderTop: "1px solid #ddd", textAlign: "center" }}>:</td>
                          <td style={{ padding: "8px", borderTop: "1px solid #ddd" }}>{entryReason}</td>
                        </tr>
                      )}
                      {rejectionRemark && (
                        <tr>
                          <td style={{ padding: "8px", borderTop: "1px solid #ddd" }}><b>Reject Remark</b></td>
                          <td style={{ padding: "8px", borderTop: "1px solid #ddd", textAlign: "center" }}>:</td>
                          <td style={{ padding: "8px", borderTop: "1px solid #ddd" }}>{rejectionRemark}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  {isAdmin && selectedTimeEntry.is_approved === 1 && (
                    <div style={{ display: 'flex', justifyContent: 'right', marginTop: '20px' }}>
                      <Button
                        className="time-entry-approve-button"
                        variant="contained"
                        color="primary"
                        size="small"
                        style={{ margin: "5px", backgroundColor: this.timeEntryModalBlue }}
                        onClick={() => {
                          this.accept(selectedTimeEntry.id);
                          this.setState({ selectedTimeEntry: false });
                        }}
                      >
                        Approve
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        style={{ margin: "5px", backgroundColor: "#db3535" }}
                        onClick={() => {
                          this.decline(selectedTimeEntry.id);
                          this.setState({ selectedTimeEntry: false });
                        }}
                      >
                        Reject
                      </Button>
                    </div>
                  )}
                </div>
              </DialogContent>
            </div>
          </Dialog>
        )}
        {editDialogOpen && editEntry && (
          <Dialog 
            open={editDialogOpen} 
            onClose={this.handleEditDialogClose} 
            disableScrollLock={true}
            aria-labelledby="form-dialog-title"
            maxWidth="sm"
            fullWidth
            PaperProps={{
              style: {
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              },
            }}
          >
            <DialogTitle
              id="form-dialog-title"
              style={{
                textAlign: "center",
                padding: "10px",
                background: "linear-gradient(180deg, var(--hrms-primary-blue-start, #036dda) 0%, var(--hrms-primary-blue-end, #036dda) 100%)",
                color: "#fff",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
                position: "relative"
              }}
            >
              Edit Time Entry
              <CloseIcon
                style={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  cursor: "pointer",
                  color: "#fff",
                  width: 28,
                  height: 28,
                }}
                onClick={this.handleEditDialogClose}
              />
            </DialogTitle>
            <DialogContent style={{ paddingTop: "20px" }}>
              <TextField
                autoFocus
                margin="dense"
                id="name"
                label="User Name"
                type="text"
                fullWidth
                value={editEntry.name}
                disabled
              />
              <TextField
                fullWidth
                id="selectedDate"
                label="Date"
                name="date"
                type="date"
                error={formErrors.selectedDate && true}
                value={this.formatDateToInput(editEntry.date)}
                InputProps={{ inputProps: { max: ds } }}
                onChange={this.handleEditChange}
                className={formErrors.selectedDate && "input-error"}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                margin="dense"
                id="start-time"
                label="Start-time"
                type="time"
                name="in_time"
                fullWidth
                value={editEntry.in_time}
                onChange={this.handleEditChange}
                error={formErrors.startTime && true}
                helperText={formErrors.startTime}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  step: 300,
                }}
              />
              <TextField
                margin="dense"
                id="end-time"
                label="End Time"
                type="time"
                name="out_time"
                fullWidth
                value={editEntry.out_time}
                onChange={this.handleEditChange}
                error={formErrors.endTime && true}
                helperText={formErrors.endTime}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  step: 300,
                }}
              />
              <TextField
                margin="dense"
                id="reason"
                label="Reason"
                type="text"
                name="reason"
                fullWidth
                value={editEntry.reason || ""}
                onChange={this.handleEditChange}
                error={formErrors.reason && true}
                helperText={formErrors.reason}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleEditDialogClose} className="btn-cancel">
                Cancel
              </Button>
              <Button onClick={this.handleEditSubmit} className="btn-success" variant="contained" color="primary">
                Save
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </div>
    );
  }
}

export default Check;
